const listingCostFragment = `
  name
  description
  type
  category
  value
  valueWithoutOffer
  frequency
  paymentDate
  payTo
  applyOn
  coveredPeriod {
    from
    to
  }
`;

export default `
  listingCosts {
    onBookingClosed {
      total
      totalWithoutOffer
      costs {
        ${listingCostFragment}
      }
    }
    onCheckIn {
      total
      costs {
        ${listingCostFragment}
      }
    }
    onCheckOut {
      total
      costs {
        ${listingCostFragment}
      }
    }
    onCheckIn {
      total
      costs {
        ${listingCostFragment}
      }
    }
    onCheckOut {
      total
      costs {
        ${listingCostFragment}
      }
    }
    duringStay {
      total
      totalWithoutOffer
      costs {
        name
        description
        type
        category
        value
        valueWithoutOffer
        frequency
        paymentDate
        payTo
        applyOn
        coveredPeriod {
          from
          to
        }
      }
    }
    extra {
      total
      costs {
        type
        value
        applyOn
        frequency
        paymentMethod
        name
        description
        payTo
      }
    }
  }
`;
